import ClaimModel from '../models/claim.model';

let storeContent = utils.generateStore({
	ClaimModel,
	allClaims: [],
	pending_fields: [],
	ads: [],
	actions: [],
	summaries: [],
	claim_policies: [],
	uploads: [],
	risks: [],
	claim_types: [],
	submited_fields: [],
	downloads: [],
	showClaimsModal: false,
	showClaimCancelationModal: false,
	showRisksModal: false,
	showMakeClaimsModal: false,
	showSubmitAdditionalInfo: false,
	showReportIncident: false,
	report_page: 1,
	claim_report_fields: {},
	selected_policy: null,
	report_type: 'incident',
	selected_policy_full: null,
	selected_risk_full: null,
	system_claim_ref: null,
	original_claim: null,
	selected_risk: null,
	selected_risk_ref: null,
	selected_claim_type_name: null,
	selected_claim_type: null,
	submission_type: 'direct',
	claim_id: '',
	benefit_name: 'Report an Incident',
	selectedClaim: {
		report_details: {
			report_details: '2020-08-14T12:39:47.247Z',
		},
		product_id: 512,
		claim_decision: 'PENDING',
		claim_type: 'ACCIDENT',
		claim_id: 1,
		claim_process: [],
	},
	activeTab: 1,
	claim_page: 1,
	keysAdded: '',
	riskDetails: null,
	makeClaimModel: {},
	AdditionalInfoModel: {},
	fields_form_data: {},
});

let director = {
	forms: [
		{
			type: 'text',
			form_type: 'text',
			class: 'col-12 col-md-4',
			model: 'firstName',
			validation: 'required|min:3|max:30',
			label: 'First Name',
			placeholder: 'Provide the First Name',
		},
		{
			type: 'text',
			form_type: 'text',
			class: 'col-12 col-md-4',
			model: 'middle',
			validation: 'required|min:3|max:30',
			label: 'Middle Name',
			placeholder: 'Provide the Middle Name',
		},
		{
			type: 'text',
			form_type: 'text',
			class: 'col-12 col-md-4',
			model: 'lastName',
			validation: 'required|min:3|max:30',
			label: 'Last Name',
			placeholder: 'Provide the Last Name',
		},
		{
			type: 'text',
			form_type: 'text',
			class: 'col-12 col-md-6',
			model: 'pin',
			validation: 'required|min:8|max:10',
			label: 'KRA Pin',
			placeholder: 'Provide the KRA pin',
		},
		{
			type: 'text',
			form_type: 'number',
			class: 'col-12 col-md-6',
			model: 'idNumber',
			validation: 'required|min:1|max:10|numeric',
			label: 'ID Number',
			placeholder: 'Provide the ID Number',
		},
		{
			type: 'mobile',
			class: 'col-12 col-md-6',
			model: 'mobileNo',
			filterable: true,
			validation: '',
			label: 'Mobile Number',
		},
		{
			type: 'select',
			class: 'col-12 col-md-6',
			model: 'residency',
			clearable: true,
			options: [
				{ val: 'Local', label: 'Local', id: '728377' },
				{ val: 'Foreign', label: 'Foreign', id: '728377' },
			],
			validation: 'required',
			label: 'Residency',
		},
		{
			type: 'select',
			class: 'col-12 col-md-6',
			model: 'type',
			clearable: true,
			options: [
				{ val: 'Executive', label: 'Executive', id: '728377' },
				{ val: 'Non-Executive', label: 'Non-Executive', id: '728377' },
			],
			validation: 'required',
			label: 'Type',
		},
		{
			type: 'textarea',
			class: 'col-12',
			model: 'description',
			rows: '4',
			validation: 'required|min:10|max:500',
			label: 'Description',
			placeholder: 'Provide a description',
		},
	],
	table: {
		icon: 'fa fa-sitemap',
		title: 'Directors',
		table_fields: [
			{ name: 'First Name', align: 'c' },
			{ name: 'Last Name', align: 'c' },
			{ name: 'Actions', align: 'c' },
		],
		search_fields: ['firstName', 'lastName'],
		row_data: [
			{ type: 'text', field: 'firstName', class: 'bold center' },
			{ type: 'text', field: 'lastName', class: 'small center' },
			{
				type: 'action',
				field: 'name',
				class: 'center',
				icon: '',
				actions: [
					// {type: 'title', title: 'Actions'},
					{ type: 'menu', title: 'View', event: 'table:view' },
					{
						type: 'menu',
						title: 'Delete',
						event: 'table:delete',
						icon: 'fa-trash-alt',
					},
				],
			},
		],
	},
};

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		openTab(ctx, page) {
			ctx.commit('activeTab', page);
		},
		async submitReview(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'claim',
							action: 'add_review',
							data: {
								claim_ref: ctx.getters.selectedClaim.claim_id,
								rating: data.rating,
								review: data.review,
							},
						},
						'/client',
					);

					ctx.commit('showAddReviews', false);
					$notify(
						'success',
						'Review Submitted',
						`Your review has been successfully submitted`,
						10,
					);
				}
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
			ctx.commit('loading', false);
		},
		async fetchClaimReviews(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'list_reviews',
						data: {
							claim_ref: ctx.getters.selectedClaim.claim_id,
						},
					},
					'/client',
				);

				ctx.commit('product_reviews', res.result.claim_reviews);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchPolicies(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'portfolio',
						action: 'list',
						data: {},
					},
					'/client',
				);

				ctx.commit('claim_policies', res.result.portfolio);
			} catch (err) {
				throw err;
			}
		},
		async fetchClaimTypes(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'claim_type',
						data: {
							system_claim_ref:
								ctx.getters.original_claim.system_claim_ref,
						},
					},
					'/client',
				);

				ctx.commit('claim_types', res.result.claim_types);
				ctx.commit(
					'system_claim_ref',
					ctx.getters.original_claim.system_claim_ref,
				);
			} catch (err) {
				throw err;
			}
		},
		async makeClaimForm(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'make_claim',
						data: {
							submission_type: ctx.getters.submission_type,
							claim_system_ref: ctx.getters.system_claim_ref,
							claim_type_code: ctx.getters.selected_claim_type,
						},
					},
					'/client',
				);
			} catch (err) {
				throw err;
			}
		},
		async saveClaimReport(ctx, payload) {
			try {
				// console.log('Saving')
				ctx.commit('loading', true);

				if (
					(!payload.make_claim &&
						(await payload.declaration_form.isValid())) ||
					payload.make_claim
				) {
					if (payload.make_claim) {
						ctx.commit(
							'fields_form_data',
							payload.claimFields.formData_,
						);
					}

					ctx.commit('keysAdded', '');
					await ctx.dispatch(
						'addReportClaimData',
						ctx.getters.fields_form_data,
					);
					let keysAdded = ctx.getters.keysAdded.substring(
						0,
						ctx.getters.keysAdded.length - 2,
					);

					ctx.commit('selected_policy', null);
					ctx.commit('selected_risk', null);
					ctx.commit('selected_claim_type', null);
					ctx.commit('claim_id', '');
					await ctx.dispatch('fetchClaims');
					$notify(
						'success',
						'Claim Submited',
						`The following items <b>${keysAdded}</b> were successfully added`,
						10,
					);

					ctx.commit('showReportIncident', false);
					ctx.commit('showMakeClaimsModal', false);
					ctx.commit('report_page', 1);
					ctx.commit('claim_page', 1);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async generateReportClaimRef(ctx, data) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'claim_report',
						data: {
							client_product_id: ctx.getters.policy_system_ref,
							claim_category: 'REPORT',
							claim_type: ctx.getters.selected_claim_type,
						},
					},
					'/client',
				);

				ctx.commit('claim_id', res.result.claim_id);
			} catch (err) {
				throw err;
			}
		},
		async addReportClaimData(ctx, data) {
			try {
				for (const [key, val] of Object.entries(data)) {
					let size = val[0];
					if (val[0]) {
						size = val[0].size;
					}
					if (val && val !== '' && !size) {
						await api.fetchEndpointSecure(
							{
								resource: 'claim',
								action: 'report',
								data: {
									system_claim_ref:
										ctx.getters.system_claim_ref,
									field_code: key,
									value: val,
								},
							},
							'/client',
						);

						ctx.commit(
							'keysAdded',
							`${ctx.getters.keysAdded}${key}, `,
						);
					}
				}

				// Submit Uploads
				for (let i = 0; i < ctx.getters.uploads.length; i++) {
					const upload = ctx.getters.uploads[i];

					if (upload.path && upload.path !== '') {
						await api.fetchEndpointSecure(
							{
								resource: 'claim',
								action: 'report',
								data: {
									system_claim_ref:
										ctx.getters.system_claim_ref,
									field_code: upload.name,
									value: upload.path,
								},
							},
							'/client',
						);

						ctx.commit(
							'keysAdded',
							`${ctx.getters.keysAdded}${upload.name}, `,
						);
					}
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchRisks(ctx) {
			try {
				//  console.log(" === Fetch risk for a policy  selected policy === ",ctx.getters.selected_policy);
				//  console.log(" === Fetch risk for a policy  selected selectedClaim === ",ctx.getters.selectedClaim)
				let res = await api.fetchEndpointSecure(
					{
						resource: 'policy',
						action: 'risks',
						data: {
							policy_system_ref:
								ctx.getters.selected_policy ||
								ctx.getters.selectedClaim.product_id,
						},
					},
					'/client',
				);

				// ctx.commit('risks', res.result.policy_risks);
				ctx.commit('risks', res.result);
			} catch (err) {
				throw err;
			}
		},
		async fetchRiskDetails(ctx, risk_system_ref) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'risk',
						action: 'get_risk_det',
						data: {
							risk_system_ref: risk_system_ref,
						},
					},
					'/client',
				);

				ctx.commit('riskDetails', res.result.risk_details);
			} catch (err) {
				throw err;
			}
		},
		async fetchPendingActions(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim_actions',
						action: 'pending',
						data: {
							claim_id: ctx.getters.selectedClaim.claim_id,
						},
					},
					'/client',
				);

				ctx.commit('actions', res.result.claim_actions);
			} catch (err) {
				throw err;
			}
		},
		async submitClaimAction(ctx, { action_ref, value }) {
			try {
				ctx.commit('loading', true);
				await api.fetchEndpointSecure(
					{
						resource: 'claim_actions',
						action: 'submit',
						data: {
							claim_action_ref: action_ref,
							claim_action_value: value,
						},
					},
					'/client',
				);

				await ctx.dispatch('fetchPendingActions');
				$notify(
					'success',
					'Action Submitted',
					`We have submitted your response`,
					10,
				);
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchReportClaimForms(ctx, data) {
			try {
				console.log(ctx.getters.selectedClaim);
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'claimform',
						data: {
							claim_system_ref: ctx.getters.system_claim_ref,
						},
					},
					'/client',
				);

				let forms = await ctx.dispatch(
					'cleanFieldsClaims',
					res.result.claim_forms,
				);

				if (
					ctx.getters.selected_claim_type_name ===
					ctx.getters.benefit_name
				) {
					await ctx.dispatch('fetchRiskBenefits');
				}
				ctx.commit('claim_report_fields', {
					data: utils.generateFormData(forms),
					name: 'claim_report_fields',
					forms,
				});

				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async makeClaim(ctx) {
			try {
				Event.$emit('loader:show', true);
				ctx.commit('showMakeClaimsModal', true);
				await ctx.dispatch('fetchClaimTypes');
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async generateAdditionalInfoForm(ctx, { pending_forms, form_ref }) {
			try {
				Event.$emit('loader:show', true);

				pending_forms = pending_forms.map((el) => {
					el.field_code = form_ref;
					return el;
				});
				let forms = await ctx.dispatch(
					'cleanFieldsClaims',
					pending_forms,
				);

				ctx.commit('AdditionalInfoModel', {
					data: utils.generateFormData(forms),
					name: 'AdditionalInfoModel',
					forms,
				});

				ctx.commit('showSubmitAdditionalInfo', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async saveClaims(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					await ctx.dispatch(
						'addMakeClaimData',
						payload.ref.formData_,
					);
					let keysAdded = ctx.getters.keysAdded.substring(
						0,
						ctx.getters.keysAdded.length - 2,
					);

					for (let i = 0; i < ctx.getters.uploads.length; i++) {
						const upload = ctx.getters.uploads[i];

						if (upload.path && upload.path !== '') {
							await api.fetchEndpointSecure(
								{
									resource: 'claim',
									action: 'report',
									data: {
										claim_system_ref:
											ctx.getters.system_claim_ref,
										claim_type_code:
											ctx.getters.selected_claim_type,
										field_code: upload.name,
										value: upload.path,
									},
								},
								'/client',
							);

							ctx.commit(
								'keysAdded',
								`${ctx.getters.keysAdded}${upload.name}, `,
							);
						}
					}
					ctx.commit('uploads', []);

					$notify(
						'success',
						'Claim Submited',
						`The following items <b>${keysAdded}</b> were successfully added`,
						5,
					);
					// await ctx.dispatch('fetchMakeClaimForms');
					// if (ctx.getters.makeClaimModel.forms.length === 0) {
					// } else {
					//   $notify(
					//     'warning',
					//     'Claim Submision In-complete',
					//     `To successfully submit, you need to provide all the form details`,
					//     10
					//   );
					// }
					ctx.commit('showMakeClaimsModal', false);
					await ctx.dispatch('fetchClaims');
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async saveAdditionalInfo(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					await ctx.dispatch(
						'addAdditionalInfo',
						payload.ref.formData_,
					);
					let keysAdded = ctx.getters.keysAdded.substring(
						0,
						ctx.getters.keysAdded.length - 2,
					);

					for (let i = 0; i < ctx.getters.uploads.length; i++) {
						const upload = ctx.getters.uploads[i];

						if (upload.path && upload.path !== '') {
							await api.fetchEndpointSecure(
								{
									resource: 'claim_additional_info',
									action: 'submit',
									data: {
										ad_info_ref: upload.name,
										ad_info_value: upload.path,
									},
								},
								'/client',
							);

							ctx.commit(
								'keysAdded',
								`${ctx.getters.keysAdded}${upload.name}, `,
							);
						}
					}
					ctx.commit('uploads', []);

					$notify(
						'success',
						'Claim Submited',
						`The following items <b>${keysAdded}</b> were successfully added`,
						5,
					);

					ctx.commit('showSubmitAdditionalInfo', false);
					await ctx.dispatch('fetchAdditionalInfo');
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchMakeClaimForms(ctx, data) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'form',
						data: {
							client_product_id:
								ctx.getters.selectedClaim.client_product_id,
							claim_type_code:
								ctx.getters.selectedClaim.claim_type,
							claim_category: 'CLAIM',
						},
					},
					'/client',
				);

				let forms = await ctx.dispatch(
					'cleanFieldsClaims',
					res.result.form_fields,
				);
				ctx.commit('makeClaimModel', {
					data: utils.generateFormData(forms),
					name: 'makeClaimModel',
					forms,
				});
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async addMakeClaimData(ctx, data) {
			try {
				for (const [key, val] of Object.entries(data)) {
					let size = val[0];
					if (val[0]) {
						size = val[0].size;
					}
					if (val && val !== '' && !size) {
						await api.fetchEndpointSecure(
							{
								resource: 'claim',
								action: 'make',
								data: {
									claim_system_ref:
										ctx.getters.system_claim_ref,
									claim_type_code:
										ctx.getters.selected_claim_type,
									field_code: key,
									value: val,
								},
							},
							'/client',
						);

						ctx.commit(
							'keysAdded',
							`${ctx.getters.keysAdded}${key}, `,
						);
					}
				}
			} catch (err) {
				throw err;
			}
		},
		async addAdditionalInfo(ctx, data) {
			try {
				for (const [key, val] of Object.entries(data)) {
					let size = val[0];
					if (val[0]) {
						size = val[0].size;
					}
					if (val && val !== '' && !size) {
						await api.fetchEndpointSecure(
							{
								resource: 'claim_additional_info',
								action: 'submit',
								data: {
									ad_info_ref: key,
									ad_info_value: val,
								},
							},
							'/client',
						);

						ctx.commit(
							'keysAdded',
							`${ctx.getters.keysAdded}${key}, `,
						);
					}
				}
			} catch (err) {
				throw err;
			}
		},
		async uploadFilesClaim(ctx, event) {
			try {
				let user = await $session.get('user');

				if (user && user.user_id) {
					for (let i = 0; i < event.files.length; i++) {
						const file = event.files[i];
						let res = await ctx.dispatch('uploadFileClaim', {
							file,
							name: event.name,
							id: user.user_id,
						});
						let uploads = ctx.getters.uploads;
						uploads.push({
							name: event.name,
							path: res.res.result.file_path,
						});
						ctx.commit('uploads', uploads);
					}
				}
			} catch (err) {
				$notify(
					'error',
					'Upload Fail',
					`Upload for ${event.name} failed. Try again`,
				);
				throw err;
			}
		},
		async uploadFileClaim(ctx, payload) {
			try {
				let bodyFormData = new FormData();
				bodyFormData.append(payload.name, payload.file);

				let res = await api.upload(
					api.parseRoute('upload/v1/client'),
					bodyFormData,
					payload.name,
				);

				$notify(
					'success',
					'Uploading File',
					`File uploaded successfully for unit ${payload.name}`,
					2,
				);

				return res;
			} catch (err) {
				throw err;
			}
		},
		async fetchClaims(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'list',
						data: {},
					},
					'/client',
				);

				ctx.commit(
					'allClaims',
					res.result.claims.sort((a, b) => {
						return Number(b.claim_id) - Number(a.claim_id);
					}),
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchAdditionalInfo(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim_additional_info',
						action: 'pending',
						data: {
							claim_ref:
								ctx.getters.original_claim.system_claim_ref,
						},
					},
					'/client',
				);

				ctx.commit(
					'pending_fields',
					res.result.pending_additional_info,
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchClaimDocuments(ctx, claim) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim_documents',
						action: 'list',
						data: {
							claim_ref: claim.claim_id,
						},
					},
					'/client',
				);

				ctx.commit('downloads', res.result.claim_documents);
			} catch (err) {
				throw err;
			}
		},
		async fetchClientSummary(ctx, claim) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'client_summary',
						data: {},
					},
					'/client',
				);

				ctx.commit('summaries', res.result.summary);
			} catch (err) {
				throw err;
			}
		},
		async viewClaim(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'details',
						data: {
							claim_id: payload.claim.claim_id,
						},
					},
					'/client',
				);

				ctx.commit('original_claim', payload.claim);
				ctx.commit('selectedClaim', res.result.claim_details);
				if (!payload.is_select) {
					await ctx.dispatch('fetchPendingActions');
					await ctx.dispatch('fetchClaimDocuments', payload.claim);
					await ctx.dispatch('fetchAdditionalInfo');

					if (
						res.result.claim_details &&
						res.result.claim_details.risk &&
						res.result.claim_details.risk.risk_system_ref
					) {
						await ctx.dispatch(
							'fetchRiskDetails',
							res.result.claim_details.risk.risk_system_ref,
						);
					}
					ctx.commit('showClaimsModal', true);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async moveToNextMakeClaim(ctx, payload) {
			try {
				ctx.commit('loading', true);
				switch (ctx.getters.claim_page) {
					case 1:
						if (ctx.getters.selected_claim_type) {
							await ctx.dispatch('makeClaimForm');
							await ctx.dispatch('fetchReportClaimForms');
							ctx.commit('submission_type', payload.type);
							ctx.commit('claim_page', 2);
						} else {
							$notify(
								'warning',
								'Select Claim Type',
								`Select a report type to continue`,
								3,
							);
						}
						break;
					default:
						ctx.commit('claim_page', ctx.getters.claim_page + 1);
						break;
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async moveToPreviousMakeClaim(ctx) {
			try {
				ctx.commit('loading', true);
				if (ctx.getters.claim_page > 1) {
					ctx.commit('claim_page', ctx.getters.claim_page - 1);
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async moveToNextReport(ctx, payload) {
			try {
				console.log('Clicked Move to Next');
				ctx.commit('loading', true);
				switch (ctx.getters.report_page) {
					case 1:
						if (ctx.getters.selected_policy) {
							await ctx.dispatch('fetchRisks');
							ctx.commit('report_page', 2);
						} else {
							$notify(
								'warning',
								'Select Policy',
								`Select a policy to continue`,
								3,
							);
						}
						break;
					case 2:
						if (ctx.getters.selected_risk) {
							console.log('On Step 2');
							ctx.commit('system_claim_ref', null);
							await ctx.dispatch('generateSystemClaimRef');

							if (ctx.getters.system_claim_ref) {
								await ctx.dispatch('fetchReportClaimForms');
								ctx.commit('report_page', 4);
							}
						} else {
							$notify(
								'warning',
								'Select Risk',
								`Select a risk to continue`,
								3,
							);
						}
						break;
					case 3:
						if (ctx.getters.selected_claim_type) {
							await ctx.dispatch('fetchReportClaimForms');
							ctx.commit('report_page', 4);
						} else {
							$notify(
								'warning',
								'Select Report Type',
								`Select a report type to continue`,
								3,
							);
						}
						break;
					case 4:
						if (await payload.claimFields.isValid()) {
							ctx.commit(
								'fields_form_data',
								payload.claimFields.formData_,
							);
							if (
								ctx.getters.selected_claim_type_name ===
								ctx.getters.benefit_name
							) {
								if (await payload.benefit_form.isValid()) {
									let form_data =
										payload.claimFields.formData_;

									// Append benefit code
									form_data[
										payload.benefit_form.formData_.risk_benefit.benefit_code
									] =
										payload.benefit_form.formData_.risk_benefit.benefit_id;
									ctx.commit('fields_form_data', form_data);
								} else {
									$notify(
										'warning',
										'Select Benefit',
										`Select a benefit to continue`,
										3,
									);
								}
							}

							ctx.commit('report_page', 5);
						}
						break;

					default:
						ctx.commit('report_page', ctx.getters.report_page + 1);
						break;
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async moveToPreviousReport(ctx) {
			try {
				ctx.commit('loading', true);
				if (ctx.getters.report_page > 1) {
					if (ctx.getters.report_page === 4) {
						ctx.commit('report_page', 2);
					} else {
						ctx.commit('report_page', ctx.getters.report_page - 1);
					}
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchReportClaimTypes(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'type',
						data: {
							client_product_id: ctx.getters.selected_policy,
						},
					},
					'/client',
				);

				ctx.commit('claim_types', res.result.portfolio_claim_types);
			} catch (err) {
				throw err;
			}
		},
		async generateSystemClaimRef(ctx, payload) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'claim_report',
						data: {
							policy_system_ref:
								ctx.getters.selected_policy_full
									.policy_system_ref,
							report_type: ctx.getters.report_type,
							risk_system_ref:
								ctx.getters.selected_risk_full.riskRef,
						},
					},
					'/client',
				);

				ctx.commit('system_claim_ref', res.result.system_claim_ref);
			} catch (err) {
				throw err;
			}
		},
		async fetchRiskBenefits(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'risk',
						action: 'benefits',
						data: {
							// risk_id: ctx.getters.selected_risk,
							risk_ref: ctx.getters.selected_risk_ref,
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: ClaimModel.forms.benefits_form,
					model: 'risk_benefit',
					label: 'benefit_name',
					data: res.result.risk_benefits,
				});

				if (form) {
					let Model = ctx.getters.ClaimModel;
					Model.forms.benefits_form = form;
					ctx.commit('ClaimModel', Model);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				await ctx.dispatch('fetchClaims');
				await ctx.dispatch('fetchPolicies');
				await ctx.dispatch('fetchClientSummary');
				// await ctx.dispatch('fetchSponsoredAds')
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async fetchSponsoredAds(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'sponsored_ads',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('ads', res.result);
			} catch (err) {
				throw err;
			}
		},
		async cleanFieldsClaims(ctx, forms) {
			let _forms = [];

			for (let i = 0; i < forms.length; i++) {
				const form = forms[i];

				if (form.type_info && form.type_info.sub_type) {
					let cleanForm = await ctx.dispatch(
						'parseFieldsClaims',
						form,
					);

					if (cleanForm) {
						_forms.push(cleanForm);
					}
				}
			}

			return _forms;
		},
		parseFieldsClaims(ctx, field) {
			if (
				field.type_info.sub_type === 'select' ||
				field.type_info.sub_type === 'radio'
			) {
				return {
					type: 'select',
					class: 'col-12',
					model: field.field_code,
					label: field.field_label,
					filterable: true,
					clearable: true,
					multiple: false,
					max_tag_count: 0,
					options: utils.unwindArrayValues(field.values),
					validation: '',
				};
			} else if (field.type_info.sub_type === 'multiple_select') {
				return {
					type: 'select',
					class: 'col-12',
					model: field.field_code,
					label: field.field_label,
					filterable: true,
					clearable: true,
					multiple: true,
					max_tag_count: 0,
					options: utils.unwindArrayValues(field.values),
					validation: '',
				};
			} else if (field.type_info.sub_type === 'multiple_select_other') {
				return {
					type: 'select_other',
					class: 'col-12',
					model: field.field_code,
					label: field.field_label,
					filterable: true,
					clearable: true,
					multiple: true,
					max_tag_count: 0,
					options: utils.unwindArrayValues(field.values),
					validation: '',
					multi_other: true,
				};
			} else if (field.type_info.sub_type === 'document') {
				return {
					type: 'upload',
					class: 'col-12',
					model: field.field_code,
					validation: '',
					label: field.field_label,
					multiple: false,
					parent_model: field.parent_code,
				};
			} else if (field.type_info.sub_type === 'image') {
				return {
					type: 'upload',
					class: 'col-12',
					model: field.field_code,
					validation: '',
					label: field.field_label,
					accept: 'image/*',
					multiple: false,
					parent_model: field.parent_code,
				};
			} else if (field.type_info.sub_type === 'color') {
				return {
					type: 'color',
					hue: true,
					alpha: true,
					model: field.field_code,
					label: field.field_label,
					recommend: false,
					colors: ['#db2828', '#f2711c', '#21ba45', '#009C95'],
					class: 'col-12',
					validation: '',
				};
			} else if (field.type_info.sub_type === 'director') {
				return {
					type: 'form-table',
					forms: director.forms,
					table: director.table,
					class: 'col-12 col-md-6',
					label: 'Directors',
					model: field.field_code,
				};
			} else if (field.type_info.sub_type === 'pdf') {
				return {
					type: 'upload',
					class: 'col-12',
					model: field.field_code,
					validation: '',
					label: field.field_label,
					accept: 'application/pdf',
					multiple: false,
				};
			} else if (field.type_info.sub_type === 'date') {
				return {
					type: 'datepicker',
					form_type: 'year',
					format: 'yyyy',
					placement: 'bottom-end',
					placeholder: field.help_text,
					model: field.field_code,
					label: field.field_label,
					class: 'col-12',
					validation: '',
				};
			} else if (field.type_info.sub_type === 'time') {
				return {
					type: 'timepicker',
					form_type: 'time',
					format: 'HH:mm',
					placeholder: field.help_text,
					model: field.field_code,
					label: field.field_label,
					class: 'col-12',
					validation: '',
				};
			} else if (field.type_info.sub_type === 'calender') {
				return {
					type: 'datepicker',
					form_type: 'date',
					format: 'dd-MM-yyyy',
					placement: 'bottom-end',
					placeholder: field.help_text,
					model: field.field_code,
					label: field.field_label,
					class: 'col-12',
					validation: '',
				};
			} else if (field.type_info.sub_type === 'date_time') {
				return {
					type: 'datepicker',
					form_type: 'datetime',
					format: 'dd-MM-yyyy hh:mm',
					placement: 'bottom-end',
					placeholder: field.help_text,
					model: field.field_code,
					label: field.field_label,
					class: 'col-12',
					validation: '',
				};
			} else if (field.type_info.sub_type === 'textarea') {
				return {
					type: 'textarea',
					class: 'col-12',
					model: field.field_code,
					rows: '4',
					validation: '',
					label: field.field_label,
					placeholder: field.help_text,
					parent_model: field.parent_code,
				};
			} else if (field.type_info.sub_type === 'location') {
				return {
					type: 'location',
					class: 'col-12',
					model: field.field_code,
					validation: '',
					label: field.field_label,
					placeholder: field.help_text,
				};
			} else {
				return {
					type: 'text',
					class: 'col-12',
					model: field.field_code,
					form_type: 'text',
					validation: '',
					label: field.field_label,
					placeholder: field.help_text,
				};
			}
		},
	},
};
